// services/emailService.js
import emailjs from "@emailjs/browser";

export const sendRegistrationEmail = (formData) => {
  const emailParams = {
    formName: "Chương trình Mỹ thuật & Lập trình cho thiếu nhi",
    fullName: formData.fullName,
    phone: formData.phone,
    email: formData.email,
    programs: formData.programs.join(", "),
    education:
      formData.education === "Khác"
        ? formData.otherEducation
        : formData.education,
    address: formData.address,
    source: formData.source === "Khác" ? formData.otherSource : formData.source,
    message: formData.message || "Không có lời nhắn",
  };

  return emailjs.send(
    "service_3oo6e54",
    "template_los1h9c",
    emailParams,
    "Fg2TttehiRc-XVVCL"
  );
};
